import { render, staticRenderFns } from "./MyCards.vue?vue&type=template&id=fd57f924&scoped=true&"
import script from "./MyCards.vue?vue&type=script&lang=ts&"
export * from "./MyCards.vue?vue&type=script&lang=ts&"
import style0 from "./MyCards.vue?vue&type=style&index=0&id=fd57f924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd57f924",
  null
  
)

export default component.exports